import { cloneDeep } from 'lodash';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { ContractProvider } from '../providers/contract.provider';
import { ProductInterface } from '../data';
import { ProductProvider } from '../providers/product.provider';
import { Transaction } from '../transaction/transaction';
import { UseCase } from './common/use.case';

@Injectable()
export class GetMyProductsUseCase implements UseCase<Observable<Transaction<ProductInterface[]>>> {
    constructor(private contractProvider: ContractProvider, private productProvider: ProductProvider) {}

    bind(): Observable<Transaction<ProductInterface[]>> {
        return this.contractProvider.current().pipe(
            switchMap((transaction) =>
                transaction.map(
                    (contract) =>
                        this.productProvider.findMine(contract.encryptedCode).pipe(
                            map((transactionProducts) =>
                                transactionProducts.map(
                                    (products) => Transaction.success(cloneDeep(products)),
                                    (throwable) => Transaction.error(throwable.message)
                                )
                            )
                        ),
                    (throwable) => of(Transaction.error(throwable.message))
                )
            )
        );
    }
}
